<script setup lang="ts">
import { computed, onMounted, ref } from 'vue';
import { EnumerationOptionDto, EnumerationValueListDto } from '@/api/generator';
import Autocomplete from '@/components/forms/Autocomplete/Autocomplete.vue';
import { EnumerationValueListProps } from '@/components/forms/types.ts';

import { translateEntityProperty } from '@/utils/helper';

const props = defineProps<EnumerationValueListProps>();

const enumerationList = defineModel<EnumerationValueListDto>('enumerationList');

const selectedOptions = ref<EnumerationOptionDto[] | null | undefined>(
  enumerationList.value?.selectedOptions,
);

const emits = defineEmits<{
  onSelectedOptionsSet: [EnumerationValueListDto];
  blur: [event: InputEvent];
}>();

const selectOptions = computed(() => {
  return enumerationList.value?.options?.map((value) => {
    return {
      title: translateEntityProperty('name', value) || '',
      value: value,
    };
  });
});

function onUpdate(input: EnumerationOptionDto[] | undefined) {
  selectedOptions.value = input;
  if (enumerationList.value) {
    enumerationList.value = { ...enumerationList.value, selectedOptions: input };
    emits('onSelectedOptionsSet', enumerationList.value);
  }
}

onMounted(() => {
  if (enumerationList.value?.selectedOptions) {
    selectedOptions.value = enumerationList.value.selectedOptions;
  }
});
</script>

<template>
  <Autocomplete
    v-bind="props"
    :items="selectOptions"
    :modelValue="selectedOptions"
    clearable
    closableChips
    multiple
    chips
    @update:modelValue="onUpdate"
    @blur="emits('blur', $event)"
  />
</template>
